import { gql } from '@apollo/client'

export const PAYMENT_ACCOUNT_LINK_SETUP = gql`
  query paymentAccountLinkSetup($accountId: String, $returnUrl: String!) {
    paymentAccountLinkSetup(accountId: $accountId, returnUrl: $returnUrl) {
      accountLink
    }
  }
`
